module.exports = __webpack_public_path__ + "img/red-white-and-brown-gift-boxes-1303081.c70a81a0.jpg";